module.exports = __webpack_public_path__ + "img/step-10.f0c4bdca.jpg";